import React from "react";
import DashboardLayout from "@/components/layout/DashboardLayout";
import { useLang } from "@/context/LangContext";
import { useTheme } from "@/context/ThemeContext";
import { Sun, Moon, Languages } from "lucide-react";

export default function Settings() {
  const { t, lang, setLang } = useLang();
  const { theme, setTheme } = useTheme();
  return (
    <DashboardLayout title={t("settings.title")} subtitle={t("settings.subtitle")}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="settings-grid">
        <div className="rounded-xl border border-zinc-800 bg-zinc-900/40 p-6">
          <div className="overline mb-4 flex items-center gap-2"><Languages className="w-3 h-3" /> {t("settings.language")}</div>
          <div className="inline-flex rounded-md border border-zinc-800 p-1">
            <button data-testid="lang-es" onClick={() => setLang("es")} className={`px-3 h-8 text-xs rounded ${lang === "es" ? "bg-white text-zinc-950" : "text-zinc-400"}`}>Español</button>
            <button data-testid="lang-en" onClick={() => setLang("en")} className={`px-3 h-8 text-xs rounded ${lang === "en" ? "bg-white text-zinc-950" : "text-zinc-400"}`}>English</button>
          </div>
        </div>
        <div className="rounded-xl border border-zinc-800 bg-zinc-900/40 p-6">
          <div className="overline mb-4">{t("settings.theme")}</div>
          <div className="inline-flex rounded-md border border-zinc-800 p-1">
            <button data-testid="theme-dark" onClick={() => setTheme("dark")} className={`px-3 h-8 text-xs rounded flex items-center gap-1 ${theme === "dark" ? "bg-white text-zinc-950" : "text-zinc-400"}`}><Moon className="w-3 h-3" /> {t("settings.dark")}</button>
            <button data-testid="theme-light" onClick={() => setTheme("light")} className={`px-3 h-8 text-xs rounded flex items-center gap-1 ${theme === "light" ? "bg-white text-zinc-950" : "text-zinc-400"}`}><Sun className="w-3 h-3" /> {t("settings.light")}</button>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}
